import { useSelector } from 'react-redux';
import { StepsStyles } from '../StepsStyles';
import { useGetAllCarriersQuery } from 'features/carriers/carrierSlice';

const CarrierOverview = ({ }) => {
    const classes = StepsStyles()

    const { accessToEdit } = useSelector(state => state.accessState);

    let { data: carriers, error: carriersError, isLoading: isLoadingCarriers } = useGetAllCarriersQuery();

    const carriersLookup = carriers?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});



    return (
        <>
            <div className={classes.overviewField}><label >Carrier: </label>{accessToEdit?.carrierName || carriersLookup[accessToEdit?.carrierId]?.name}</div>
            <div className={classes.overviewField}><label >SCAC: </label>{accessToEdit?.scac || carriersLookup[accessToEdit?.carrierId]?.scac}</div>
        </>
    );
}

export default CarrierOverview;